import React, { useEffect } from 'react'
import { BrowserRouter, useRoutes } from 'react-router-dom'
import { routes } from './routes'
import { ClerkProvider } from '@clerk/react-router'
// import ChatWidget from '../../widgets/ChatWidget/ChatWidget'

function AppRoutes() {
	return useRoutes(routes)
}

export function RouterProvider() {
	const pk = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY
	const clerkDomain = process.env.REACT_APP_CLERK_DOMAIN
	if (!pk) throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY')

	useEffect(() => {
		const setAppHeight = () => {
			const vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', `${vh}px`)
		}

		setAppHeight()
		window.addEventListener('resize', setAppHeight)
		window.addEventListener('orientationchange', setAppHeight)

		return () => {
			window.removeEventListener('resize', setAppHeight)
			window.removeEventListener('orientationchange', setAppHeight)
		}
	}, [])

	return (
		<BrowserRouter>
			<ClerkProvider
				publishableKey={pk}
				signInUrl="/auth"
				signUpUrl="/auth?mode=signup"
				fallbackRedirectUrl="/"
				signUpFallbackRedirectUrl="/"
				domain={clerkDomain}
			>
				<AppRoutes />
				{/* <ChatWidget /> */}
			</ClerkProvider>
		</BrowserRouter>
	)
}
